// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"WordsMeaningButtonGroup_buttonGroup__36t0H","active":"WordsMeaningButtonGroup_active__24CLY"};